// extracted by css-extract-rspack-plugin
export default {"dropzone":"ProfilePictureInput__dropzone___SQsMC","iconStyle":"ProfilePictureInput__iconStyle___vqon0","descriptionStyle":"ProfilePictureInput__descriptionStyle___r4uiE"};